import { render } from "./page-404-layout.vue?vue&type=template&id=80b1606e"
const script = {}
script.render = render

export default script